var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('h4',[_vm._v("Total: "+_vm._s(_vm.data.length)+" client"+_vm._s(_vm.data.length > 1 ? "s" : "")+".")]),_c('div',{staticClass:"mt-2"},_vm._l((_vm.completeLostReason),function(lostReason){return _c('div',{key:lostReason.value},[(
          _vm.data.filter(
            (client) => client.lostReason.value === lostReason.value
          ).length > 0
        )?_c('div',{style:(_vm.getLostReasonColor(lostReason.value))},[_vm._v(" "+_vm._s(lostReason.label)+": "+_vm._s(_vm.data.filter( (client) => client.lostReason.value === lostReason.value ).length)+" ")]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }